import * as React from 'react';
import { t } from 'i18next';

import { BaseComponent } from '../BaseComponent';
import { LayoutType } from '../../constants/LayoutConstants';
import { GroundType, ProjectSettingsStore } from '../../stores/ProjectSettingsStore';
import { PopupMenu } from '../../constants/Enums';
import { VisibilityActions } from '../../actions/VisibilityActions';
import { ProjectSettingsActions } from '../../actions/ProjectSettingsActions';
import { GlobalHelper, ColorRGB } from '../../utils/GlobalHelper';
import { DialogActions } from '../../actions/DialogActions';
import { ClickButton } from '../ClickButton';
import { PlannerCoreColorPicker } from '../PlannerCoreColorPicker';

interface EnvironmentFloorPlanSetupProps extends React.Props<EnvironmentFloorPlanSetup> {
    layoutType: LayoutType;
}

interface EnvironmentFloorPlanSetupState {
    groundType: GroundType | 'floorplan';
    open: boolean;
}

export class EnvironmentFloorPlanSetup extends BaseComponent<EnvironmentFloorPlanSetupProps, EnvironmentFloorPlanSetupState> {
    protected coreColorPicker: PlannerCoreColorPicker | null;
    public componentWillMount(): void {
        this.addStoreListener(ProjectSettingsStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element {
        return (
            <div className="floorplan-setup">
                <div className="egr-select-option-header">
                    <span>{t('Environment / Floor plan')}</span>
                    <div className="floorplan-setup-close sprite-icon-close" onClick={() => { VisibilityActions.setPopupMenu(PopupMenu.NONE); }} />
                </div>
                <div className="floorplan-setup-content">
                    <div className="radiogroup">
                        <div className={'radio' + (this.state.groundType === 'nofloor' || this.state.groundType === 'solid' ? ' radio--checked' : '')}>
                            <div className="radio__icon" onClick={this.showSolidFloor} />
                            <div className="radio__label" onClick={this.showSolidFloor}>{t('Color')}</div>
                            <PlannerCoreColorPicker
                                ref={(node) => this.coreColorPicker = node}
                                height={100}
                                widthPan={180}
                                spaceWidth={12}
                                widthSlider={18}
                                // initialValue={this.state.groundType === 'nofloor' ? null : ProjectSettingsStore.getState().groundColor}
                                initialValue={ProjectSettingsStore.getState().groundColor}
                                onChange={this.setColor}
                                defaultColors={[
                                    null,
                                    { r: 246, g: 240, b: 225 },
                                    { r: 97, g: 67, b: 34 },
                                    { r: 104, g: 119, b: 148 },
                                    { r: 79, g: 79, b: 79 },
                                    { r: 178, g: 178, b: 178 },
                                    ProjectSettingsStore.defaultGroundColor,
                                ]}
                            />
                        </div>
                        <div className={'radio' + (this.state.groundType === 'floorplan' ? ' radio--checked' : '')}>
                            <div className="radio__icon" onClick={this.showFloorPlan} />
                            <div className="radio__label" onClick={this.showFloorPlan}>{t('Floor Plan')}</div>
                            <ClickButton className="btn" callback={this.uploadFloorPlan}>
                                <div className="btn__label">{t('Upload')}</div>
                                <div className="btn__icon icon-upload-dark" />
                            </ClickButton>
                            <ClickButton
                                className="btn"
                                callback={this.editFloorPlan}
                                disabled={GlobalHelper.floorPlan == null || !GlobalHelper.floorPlan.hasTexture()}
                            >
                                <div className="btn__label">{t('Edit')}</div>
                                <div className="btn__icon icon-pen-dark" />
                            </ClickButton>
                        </div>
                        <div className={'radio' + (this.state.groundType === 'tiledfloor' ? ' radio--checked' : '')}>
                            <div className="radio__icon" onClick={this.setGroundType('tiledfloor')} />
                            <div className="radio__label" onClick={this.setGroundType('tiledfloor')}>{t('Tiled Floor')}</div>
                        </div>
                        <div className={'radio' + (this.state.groundType === 'woodenfloor' ? ' radio--checked' : '')}>
                            <div className="radio__icon" onClick={this.setGroundType('woodenfloor')} />
                            <div className="radio__label" onClick={this.setGroundType('woodenfloor')}>{t('Wooden Floor')}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    protected onChange = (): void => {
        this.setState({
            groundType: ProjectSettingsStore.getFloorPlanVisibility() ? 'floorplan' : ProjectSettingsStore.getState().groundType
        });
    };

    protected setColor = (value: ColorRGB | null): void => {
        if (value) {
            ProjectSettingsActions.setGroundColor(value);
            ProjectSettingsActions.setGroundType('solid');
        } else {
            ProjectSettingsActions.setGroundType('nofloor');
        }
    };

    protected showSolidFloor = (): void => {
        if (this.coreColorPicker && this.coreColorPicker.state.activeColor) {
            ProjectSettingsActions.setGroundType('solid');
        } else {
            ProjectSettingsActions.setGroundType('nofloor');
        }
    };

    protected showFloorPlan = (): void => {
        if (GlobalHelper.floorPlan == null || !GlobalHelper.floorPlan.hasTexture()) {
            DialogActions.triggerFloorPlanUpload();
        } else {
            ProjectSettingsActions.showFloorPlan();
        }
    };

    protected uploadFloorPlan = (): void => {
        DialogActions.triggerFloorPlanUpload();
    };

    protected editFloorPlan = (): void => {
        if (GlobalHelper.floorPlan !== null && GlobalHelper.floorPlan.hasTexture()) {
            ProjectSettingsActions.showFloorPlan();
            VisibilityActions.setPopupMenu(PopupMenu.FLOORPLAN_SETUP);
        }
    };

    protected setGroundType = (groundType: GroundType) => () => {
        ProjectSettingsActions.setGroundType(groundType);
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/popupmenu/EnvironmentFloorPlanSetup.tsx